module.exports = __webpack_public_path__ + "img/Checkbox_pressed.00d13211.svg";